import http from './api'

// Fund valuation reports (FactFund replacement): one row per fund report and portfolio,
// with the fund's own report attached. The server orders the list newest first.
const url = `/private_investment_funds/fund_valuation_reports/`

export const httpGetFundValuationReports = (params) => {
  return http({
    url,
    method: 'GET',
    params,
  })
}

export const httpCreateFundValuationReport = (data) => {
  return http({
    url,
    method: 'POST',
    data,
  })
}

export const httpUpdateFundValuationReport = (id, data) => {
  return http({
    url: `${url}${id}/`,
    method: 'PATCH',
    data,
  })
}

export const httpDeleteFundValuationReport = (id) => {
  return http({
    url: `${url}${id}/`,
    method: 'DELETE',
  })
}

export const httpUploadFundValuationReportAttachment = (id, file) => {
  const data = new FormData()
  data.append('file', file)
  return http({
    url: `${url}${id}/attachment/`,
    method: 'POST',
    data,
  })
}

export const httpGetFundValuationReportAttachment = (id) => {
  return http({
    url: `${url}${id}/attachment/`,
    method: 'GET',
    responseType: 'blob',
  })
}

export const httpDeleteFundValuationReportAttachment = (id) => {
  return http({
    url: `${url}${id}/attachment/`,
    method: 'DELETE',
  })
}
